import { types } from "./mutations";
import omit from "lodash/omit";

export default {
  /**
   * Adds a layer to the layers object
   */
  addLayer: async ({ commit, state }, layer) => {
    commit(types.SET_LAYERS, {
      ...state.layers,
      [layer.id]: layer,
    });
    return layer.id;
  },

  /**
   *  deletes an exisiting layer from the layers object
   */
  deleteLayer: async ({ commit, state }, { layer_id }) => {
    commit(types.SET_LAYERS, {
      ...omit(state.layers, layer_id), // omits the entry with the layer id
    });
  },

  /**
   * updates an exisiting layer with new data
   */
  updateLayer: async ({ commit, state }, layer) => {
    // check for layers and if the particular layer exists in the store to update
    if (!(state.layers && state.layers.length > 0 && state.layers[layer.id]))
      return;
    commit(types.SET_LAYERS, {
      ...state.layers,
      [layer.id]: {
        ...state.layers[layer.id], // add the initial layer data
        ...layer, // override the initial data with new ones
      },
    });
  },

  /**
   * Sets an active layer based on given configuration
   * @param { Object } context
   * @param {Object} layer_details
   * @param {String} layer_details.layer_id Id of the layer
   * @param {String} layer_details.layer_level Which level the layer should be activated. ["primary", "secondary", "overlay"]
   * @param {String} layer_details.allow_multiple Whether to allow multiple layers
   */
  setActiveLayer: async (
    { commit, state },
    { layer_id, layer_level = "primary", allow_multiple = false }
  ) => {
    try {
      // check if the layer object is present or not
      if (!(state.activeLayers && Object.keys(state.activeLayers).length > 0)) {
        // if not, set a fresh object
        commit(types.SET_ACTIVE_LAYERS, {
          [layer_level]: layer_id,
        });
      } else {
        // else, override the existing layer registry
        commit(types.SET_ACTIVE_LAYERS, {
          ...state.activeLayers,
          [layer_level]: layer_id,
        });
      }

      // TODO: implement ability to add multiple layers using allow_multiple
    } catch (error) {
      console.error("Setting active layer", { error });
    }
  },

  reset: async ({ commit }) => {
    commit(types.reset);
  },
};
